module.exports = __webpack_public_path__ + "posture/static/img/knee_overstretch_normal.55c035f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/knee_overstretch_normal.png
// module id = D0EO
// module chunks = 1